import { ViteReactSSG } from "vite-react-ssg";

import "@fontsource-variable/fraunces";
import "@fontsource-variable/inter";
import "@fontsource-variable/geist";
import "@fontsource/cinzel/400.css";
import "@fontsource/cinzel/500.css";
import "@fontsource/cinzel/600.css";
import "@fontsource/cinzel/700.css";
import "@/index.css";
import "@/styles/tokens.css";
import "@/styles/base.css";
import "@/App.css";

import { routes } from "@/App";

/* vite-react-ssg entry. On the server it pre-renders each route to static HTML; on the
   client it hydrates the same tree via createBrowserRouter — same components, same
   appearance. The route list lives in @/App. */
export const createRoot = ViteReactSSG({ routes });
